import type { ComponentProps } from "react"
import { DialogTrigger as DialogTriggerBase } from "@/v2-ui/dialog/base/DialogBase"

export type DialogTriggerProps = ComponentProps<typeof DialogTriggerBase>

function DialogTrigger(props: DialogTriggerProps) {
  const { ...dialogTriggerBaseProps } = props
  return <DialogTriggerBase {...dialogTriggerBaseProps} />
}

export default DialogTrigger
